module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Please select the editor you want to download."},"zh-CN":{"select":"请选择需要下载的编辑器"},"zh-TW":{"select":"請選擇需要下載的編輯器"},"it":{"select":"Seleziona l\u0027editor che desideri scaricare."},"id":{"select":"Silahkan pilih editor yang ingin diunduh"}}')
  delete Component.options._Ctor
}
